var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #ffbc15;\n      }\n\n      .cls-4 {\n        fill: #f7fafb;\n      }\n\n      .cls-5 {\n        opacity: .5;\n      }\n\n      .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-7 {\n        fill: #ff5226;\n      }\n\n      .cls-8 {\n        fill: #f4f3e1;\n      }\n\n      .cls-9 {\n        fill: #f9ae3b;\n      }\n\n      .cls-10 {\n        fill: #f9f2d2;\n      }\n\n      .cls-11 {\n        fill: #ced1d2;\n        mix-blend-mode: multiply;\n      }\n\n      .cls-12 {\n        fill: #ffcc3e;\n      }\n\n      .cls-13 {\n        fill: #ff6e3b;\n      }\n\n      .cls-14 {\n        fill: #d3e2f9;\n      }\n\n      .cls-15 {\n        fill: #f7941d;\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 203.63,
    y1: 562.53,
    x2: 802.46,
    y2: 562.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa501"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 515.7,
    y1: 257.18,
    x2: 515.7,
    y2: 598.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc3700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 502.24,
    y1: 441.97,
    x2: 524.53,
    y2: 441.97,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 247.92,
    y1: 544.82,
    x2: 299.68,
    y2: 736.01,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M759.49,295.86l-403.06,.26-17.59-32.82c-2.27-4.23-6.68-6.88-11.49-6.87l-87.83,.06c-7.41,0-13.42,6.02-13.41,13.43l.02,26.29,.07,114.72,553.76-.36-.06-94.32c0-11.27-9.15-20.4-20.42-20.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M783.54,730.14l-560.75,.36c-10.46,0-18.94-8.47-18.95-18.92l-.21-329.83c0-10.46,8.47-18.94,18.92-18.95l560.75-.36c10.46,0,18.94,8.47,18.95,18.92l.21,329.83c0,10.46-8.47,18.94-18.92,18.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M759.36,310.86l-403.06,.26-17.59-32.82c-2.27-4.23-6.68-6.88-11.49-6.87l-87.83,.06c-7.41,0-13.42,6.02-13.41,13.43l.02,26.29,.07,114.72,553.76-.36-.06-94.32c0-11.27-9.15-20.4-20.42-20.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 235.96,
    y: 340.44,
    width: 533.91,
    height: 42.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M783.54,746.2l-560.75,.36c-10.46,0-18.94-8.47-18.95-18.92l-.21-329.83c0-10.46,8.47-18.94,18.92-18.95l560.75-.36c10.46,0,18.94,8.47,18.95,18.92l.21,329.83c0,10.46-8.47,18.94-18.92,18.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M515.9,204.58l-7.17,2.4-.54,.18-.17,.06-.17,.06-176.62,62.27-14.81,5.22,.12,15.7c.02,2.87,.78,71.27,23.71,149.71,13.63,46.66,32.34,87.22,55.6,120.57,29.42,42.18,66.15,72.85,109.2,91.17l3.97,2.63h11.01l4.11-1.68c43.88-18.18,81.28-49.06,111.17-91.8,23.33-33.36,42.1-73.96,55.78-120.67,23-78.54,23.78-147.05,23.8-149.93l.12-15.7-14.81-5.22-177.16-62.46-7.13-2.51h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M692.86,286.23s-2.05,269.69-177.15,342.25h-.07c-.18-.13-.3-.18-.48-.25-174.62-72.78-176.62-342-176.62-342l176.62-62.26,.55-.18,177.15,62.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M515.17,223.36v404.27c-174.62-72.79-176.62-342-176.62-342l176.62-62.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M558.03,360.34c-4.55-20.46-22.84-35.81-44.65-35.81s-40.11,15.35-44.66,35.81c-.71,3.2-1.09,6.53-1.09,9.94v46.65h91.48v-46.65c0-3.41-.38-6.74-1.09-9.94Zm-16.3,39.19h-56.69v-29.26c0-3.49,.63-6.85,1.8-9.94,4.03-10.76,14.41-18.42,26.55-18.42s22.52,7.67,26.55,18.42c1.17,3.09,1.8,6.45,1.8,9.94v29.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M587.3,396v82.07c0,9.16-7.43,16.58-16.58,16.58h-114.68c-9.14,0-16.57-7.43-16.57-16.58v-82.07c0-2.87,.73-5.57,2.01-7.92,2.81-5.16,8.27-8.66,14.56-8.66h114.68c6.28,0,11.76,3.5,14.57,8.66,1.29,2.35,2.01,5.05,2.01,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M524.53,430.25c0-6.16-4.99-11.15-11.15-11.15s-11.15,4.99-11.15,11.15c0,4.21,2.34,7.88,5.79,9.78v24.82h10.71v-24.82c3.45-1.89,5.79-5.56,5.79-9.78Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M360.96,717.67l-134.12,29.55c-5.59,1.23-11.12-2.3-12.35-7.89l-37.7-171.08c-1.23-5.59,2.3-11.12,7.89-12.35l134.12-29.55c5.59-1.23,11.12,2.3,12.35,7.89l37.7,171.08c1.23,5.59-2.3,11.12-7.89,12.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.94,599.63l6.38,28.94-49.33,10.87-6.38-28.94c-1.22-5.53,1.12-10.98,5.47-14.03,4.89,4.12,11.58,6,18.3,4.52,6.7-1.48,11.98-5.99,14.69-11.79,5.23,.93,9.65,4.9,10.86,10.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264.35,596.3c-8.88,1.96-17.69-3.68-19.65-12.55-1.96-8.88,3.68-17.69,12.55-19.65,8.88-1.96,17.69,3.68,19.65,12.55,1.96,8.88-3.68,17.69-12.55,19.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 218.37,
    y: 652.9,
    width: 116.04,
    height: 4.59,
    transform: "translate(-134.51 74.83) rotate(-12.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 222.03,
    y: 669.48,
    width: 116.04,
    height: 4.59,
    transform: "translate(-137.99 76) rotate(-12.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 225.68,
    y: 686.05,
    width: 116.04,
    height: 4.59,
    transform: "translate(-141.48 77.18) rotate(-12.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.33,
    y: 702.63,
    width: 116.04,
    height: 4.59,
    transform: "translate(-144.96 78.35) rotate(-12.43)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "420.29 569.07 420.29 746.37 303.32 746.37 303.32 597.07 330.53 569.07 420.29 569.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "330.53 569.07 330.53 597.07 303.32 597.07 330.53 569.07"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.17,
    y: 604.78,
    width: 73.26,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.17,
    y: 619.55,
    width: 73.26,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.17,
    y: 634.33,
    width: 73.26,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.17,
    y: 649.1,
    width: 73.26,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.17,
    y: 663.88,
    width: 73.26,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.17,
    y: 678.65,
    width: 73.26,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.17,
    y: 693.43,
    width: 73.26,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.17,
    y: 708.2,
    width: 73.26,
    height: 2.46
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 723.76,
    y: 576.73,
    width: 156.3,
    height: 156.3,
    transform: "translate(208.47 -193.5) rotate(15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 734.93,
    y: 587.9,
    width: 133.97,
    height: 133.97,
    transform: "translate(208.47 -193.5) rotate(15.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M792.6,613.96c-2.18,7.71-10.2,12.2-17.91,10.02-7.71-2.18-12.2-10.2-10.02-17.91,2.18-7.71,10.2-12.2,17.91-10.02,7.71,2.18,12.2,10.2,10.02,17.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M861.69,669.14l-17.35,61.36h-.65s-117.57-33.25-117.57-33.25l6.88-24.32h0c13.94-7.83,31.59-2.85,39.37,11.13l3.32,5.96,53.69-30.02c11.45-6.4,25.91-2.31,32.31,9.14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "636.8 588.72 560.98 654.74 712.4 653.75 636.8 588.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 561.28,
    y: 654.24,
    width: 151.43,
    height: 93.28,
    transform: "translate(-4.53 4.15) rotate(-.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M585.98,619.56h102.02c4.89,0,8.85,3.97,8.85,8.85v84.91c0,4.89-3.97,8.85-8.85,8.85h-102.02c-4.89,0-8.85-3.97-8.85-8.85v-84.91c0-4.89,3.97-8.85,8.85-8.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "615.6 702 561.57 748.01 560.97 655.87 615.6 702"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "713.01 747.64 657.84 701.81 712.4 654.89 713.01 747.64"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "636.57 683 560.95 747.41 713.63 747.03 636.57 683"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 611.97,
    y: 631.2,
    width: 51.46,
    height: 51.46,
    rx: 10.92,
    ry: 10.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 614.66,
    y: 633.89,
    width: 46.07,
    height: 46.07,
    rx: 9.78,
    ry: 9.78
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M624.9,659.24c0-9.19,6.65-15.22,14.34-15.22,6.93,0,11.29,4.62,11.29,11.4,0,6-3.74,9.12-6.87,9.12-1.88,0-3.32-.87-3.56-2.61h-.07c-1.11,1.33-2.66,2.35-4.17,2.35-2.34,0-4.15-1.74-4.15-4.86,0-3.66,2.6-7.98,6.6-7.98,1.19,0,2.12,.52,2.76,1.67h.07l.38-1.4h1.88l-1.35,6.88c-.67,2.72-.02,4.02,1.88,4.02,2.15,0,4.61-2.64,4.61-7.1,0-5.54-3.27-9.6-9.52-9.6s-12.02,5.21-12.02,13.22c0,6.72,4.38,10.52,10.22,10.52,2.08,0,4.02-.64,5.56-1.54l.76,1.69c-2,1.19-4.16,1.75-6.54,1.75-6.72,0-12.09-4.3-12.09-12.32Zm14.66,1.07l.97-5.46c-.65-1.04-1.28-1.43-2.2-1.43-2.7,0-4.36,3.25-4.36,5.84,0,2.21,1.03,3.08,2.41,3.08,.97,0,1.99-.6,3.18-2.03Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.0d1a6d80d804e75da94dff7913b9c6f9.svg";
export { ForwardRef as ReactComponent };